import { render, staticRenderFns } from "./PaginaCalendarioMinistero.vue?vue&type=template&id=0a5fa231"
import script from "./PaginaCalendarioMinistero.vue?vue&type=script&lang=js"
export * from "./PaginaCalendarioMinistero.vue?vue&type=script&lang=js"
import style0 from "./PaginaCalendarioMinistero.vue?vue&type=style&index=0&id=0a5fa231&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports